import { FlatTreeRow, TreeTableRow } from './types';

/**
 * Flattens rows depth-first into display order. A row's children are included only while it is expanded: either
 * `alwaysExpanded` or `isExpanded(row.id)`. Collapsed children are not returned.
 */
export const flattenTree = <T>(rows: TreeTableRow<T>[], isExpanded: (id: string) => boolean): FlatTreeRow<T>[] => {
  const result: FlatTreeRow<T>[] = [];

  const visit = (list: TreeTableRow<T>[], depth: number) => {
    list.forEach((row) => {
      const hasChildren = (row.children?.length ?? 0) > 0;
      const collapsible = hasChildren && !row.alwaysExpanded;
      const expanded = hasChildren && (row.alwaysExpanded === true || isExpanded(row.id));
      result.push({ row, depth, hasChildren, expanded, collapsible });
      if (expanded && row.children) visit(row.children, depth + 1);
    });
  };

  visit(rows, 0);
  return result;
};
